import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { ChevronRight } from '@mxenabled/mx-icons'

import { Drawer, ToggleButtonListItem, useSettingsStore } from '../../../common'
import { DetailedNotificationProfile } from '../../../core'

import { AccountNotificationProfile } from './AccountNotificationProfile'

export const AccountNotificationProfiles = observer(() => {
  const { accountProfiles, updateNotificationProfile } = useSettingsStore()

  const [selectedProfileGuid, setSelectedProfileGuid] = React.useState('')

  const selectedProfile = React.useMemo(
    () => accountProfiles.find((profile) => profile.guid === selectedProfileGuid),
    [accountProfiles, selectedProfileGuid],
  )

  const handleProfileToggle = async (profile: DetailedNotificationProfile) => {
    await updateNotificationProfile({
      ...profile,
      is_enabled: !profile.is_enabled,
    })
  }

  const handleProfileUpdate = async (profile: DetailedNotificationProfile) => {
    await updateNotificationProfile(profile)
  }

  return (
    <Stack sx={{ backgroundColor: 'background.paper' }}>
      {accountProfiles
        // Don't show notification profiles that have no associated accounts (children)
        .filter((profile) => profile.children && profile.children.length > 0)
        .map((profile) => (
          <ToggleButtonListItem
            endIcon={<ChevronRight />}
            isChecked={profile.is_enabled}
            isDisabled={!profile.is_enabled}
            key={profile.guid}
            onClick={() => setSelectedProfileGuid(profile.guid)}
            onToggle={() => handleProfileToggle(profile)}
            primaryText={profile.label}
            secondaryText={profile.is_enabled ? profile.deliveryMethodsLabel : undefined}
          />
        ))}
      <Drawer
        isOpen={Boolean(selectedProfile)}
        onClose={() => setSelectedProfileGuid('')}
        title={selectedProfile ? selectedProfile.label : ''}
      >
        {selectedProfile && (
          <AccountNotificationProfile
            onUpdateProfile={handleProfileUpdate}
            profile={selectedProfile}
          />
        )}
      </Drawer>
    </Stack>
  )
})
